import React from "react";

export default function Object({ id, src, object, onClick }) {
	return <img className={`object ${object} `} id={id} src={src} alt='' onClick={onClick} />;
}
